import { Button } from "@/components/ui/button";
import { ChevronDown } from "lucide-react";

export default function HeroSection() {
  const scrollToMenu = () => {
    document.querySelector("#evening-menu")?.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToContact = () => {
    document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section data-testid="hero-section" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-[#02120D]">
      {/* Content */}
      <div className="relative z-10 flex flex-col items-center px-4 max-w-4xl mx-auto">
        <div className="mb-8 animate-fade-in-up text-center">
          <h1 className="font-['Playfair_Display'] text-5xl sm:text-6xl lg:text-7xl font-semibold text-[#F0FDF4] tracking-tight drop-shadow-2xl">
            Veranda
          </h1>
          <p className="font-['Playfair_Display'] text-3xl sm:text-4xl lg:text-5xl font-medium text-[#EAB308] tracking-tight mt-2">
            pod Soutokem
          </p>
        </div>

        <p className="text-base sm:text-lg text-[#E2E8F0]/80 max-w-xl text-center mb-4 animate-fade-in-up animation-delay-200 font-light">
          Poctivá česko-ukrajinská kuchyně v srdečné atmosféře
        </p>

        <div className="flex items-center justify-center gap-6 text-sm text-[#94A3B8] mb-10 animate-fade-in-up animation-delay-200">          <span className="flex items-center gap-2">
            <span className="w-1.5 h-1.5 rounded-full bg-[#EAB308]" />
            Výhodné polední menu
          </span>
          <span className="w-px h-4 bg-[#1D4133]" />
          <span className="flex items-center gap-2">
            <span className="w-1.5 h-1.5 rounded-full bg-[#EAB308]" />
            Večeře v příjemné atmosféře
          </span>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-in-up animation-delay-300">          <Button
            onClick={scrollToMenu}
            data-testid="hero-cta-menu"
            className="bg-[#EAB308] text-[#02120D] hover:bg-yellow-500 rounded-sm font-semibold uppercase tracking-wider px-8 py-3 text-sm"
          >
            Prohlížet menu
          </Button>
          <Button
            onClick={scrollToContact}
            variant="outline"
            data-testid="hero-cta-contact"
            className="border-[#EAB308] text-[#EAB308] hover:bg-[#EAB308] hover:text-[#02120D] rounded-sm uppercase tracking-wider px-8 py-3 text-sm bg-transparent"
          >
            Kontakt na nás
          </Button>
        </div>
      </div>

      {/* Scroll indicator */}
      <button
        onClick={() => document.querySelector("#about")?.scrollIntoView({ behavior: "smooth" })}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 text-[#94A3B8] animate-bounce"
        data-testid="scroll-down-btn"
      >
        <ChevronDown className="w-6 h-6" />
      </button>
    </section>
  );
}
